import { render } from "./AppointmentTypesManagement.vue?vue&type=template&id=c37574c8&scoped=true"
import script from "./AppointmentTypesManagement.vue?vue&type=script&lang=js"
export * from "./AppointmentTypesManagement.vue?vue&type=script&lang=js"

import "./AppointmentTypesManagement.vue?vue&type=style&index=0&id=c37574c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37574c8"]])

export default __exports__